export { default } from "./Card";



// WEBPACK FOOTER //
// ./src/components/emission/cards/Card/index.js